import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { useEffect, useState } from 'react';
import { auth, onAuthStateChanged } from '@/lib/firebase';
import Login from '@/pages/Login';
import Boards from '@/pages/Boards';
import BoardView from '@/pages/BoardView';
import Analytics from '@/pages/Analytics';
import Tutorial from '@/pages/Tutorial';
import Contact from '@/pages/Contact';
import FAQ from '@/pages/FAQ';
import LandingPage from '@/components/LandingPage';
import { MainHeader } from '@/components/MainHeader';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, user => {
      setIsAuthenticated(!!user);
    });
    return unsub;
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white" />
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
}

function BoardRedirect() {
  const { boardId } = useParams();
  return <Navigate to={`/boards/${boardId}`} replace />;
}

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background">
        <MainHeader />
        <main>
          <Routes>
            <Route path="/"         element={<LandingPage />} />
            <Route path="/login"    element={<Login />} />
            <Route path="/tutorial" element={<Tutorial />} />
            <Route path="/faq"      element={<FAQ />} />

            <Route path="/dashboard" element={<ProtectedRoute><Navigate to="/boards" replace /></ProtectedRoute>} />
            <Route path="/boards"    element={<ProtectedRoute><Boards /></ProtectedRoute>} />
            <Route path="/board/:boardId"  element={<ProtectedRoute><BoardRedirect /></ProtectedRoute>} />
            <Route path="/boards/:boardId" element={<ProtectedRoute><BoardView /></ProtectedRoute>} />
            <Route path="/analytics"       element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
            <Route path="/contact"         element={<ProtectedRoute><Contact /></ProtectedRoute>} />
          </Routes>
        </main>
      </div>
      <Toaster />
    </Router>
  );
}
